import TPhoneBookAddOneByOne from './index.vue';

TPhoneBookAddOneByOne.install = app => {
  app.component(TPhoneBookAddOneByOne.name, TPhoneBookAddOneByOne);
};

export default TPhoneBookAddOneByOne;
